import React from 'react';

export default function Logo({ height = 24, style = {} }) {
  return (
    <img
      src="/web-ios-logo.svg"
      alt="OtoFlow"
      style={{ height, width: 'auto', display: 'block', ...style }}
    />
  );
}
